<template>
  <div :id="$attrs['id']"
       :class="[$attrs['class']]"
       contenteditable="contenteditable"
       @input="updateInput"
       @blur="onBlur"
       @focus="onFocus"
       @keypress="onKeypress"
       @keyup.enter="$emit('submit', $event)">
    <span v-if="!focus && isEmpty(content)" class="placeholder" v-html="placeholder"></span>
    {{ content }}
  </div>
</template>

<script>

import { isEmpty } from 'lodash';
import striptags from 'striptags';

export default {
  props: ['value', 'placeholder'],
  data() {
    return {
      content: this.value,
      focus: false,
    };
  },
  watch: {
    value: function (newVal) {
      // this.content = newVal;
    },
  },
  methods: {
    isEmpty(val) {
      return isEmpty(val);
    },
    onBlur($event) {
      this.focus = false;
      this.$emit('blur', $event);
    },
    onFocus($event) {
      this.focus = true;
      this.$emit('focus', $event);
    },
    onKeypress(event) {
      if (event.which === 13) {
        event.preventDefault();
        this.$emit('submit', event);
      }
    },
    updateInput(event) {
      this.$emit('input', striptags(event.target.innerText));
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~styles/import';

  .placeholder {
    color: $middlegray;
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/ContenteditableDiv.vue